import { useEffect, useState } from "react";
import { OptionsFTP } from "./OptionsFTP";
import { Adress } from "../../../helpFunction/urlList";
import { clearCookies, readCookies } from "../../../helpFunction/helpFunction";

interface Props {
	setBars: (e: boolean) => void;
	setShowMenuOptions: (e: boolean) => void;
}
export const MenuOptions = (props: Props) => {
	const [ustawieniaFTP, setUstawieniaFTP] = useState(false);
	const [checkBox, setCheckBox] = useState(false);
	const handlerUstawieniaFTP = () => {
		setUstawieniaFTP(true);
	};

	useEffect(() => {
		const scroll = document.querySelector(".slider");
		const list = scroll?.classList.value;
		list?.includes("notSchow") ? setCheckBox(false) : setCheckBox(true);
	}, [checkBox]);
	const logout = async () => {
		await fetch(Adress.logOut, {
			headers: {
				auth: readCookies().auth,
			},
		});
		await clearCookies();
		document.location.reload();
	};
	const checkBoxChange = () => {
		const scroll = document.querySelector(".slider");
		setCheckBox(!checkBox);
		if (checkBox) {
			scroll?.classList.add("notSchow");
		} else {
			scroll?.classList.remove("notSchow");
		}
	};

	return (
		<>
			<div className="MenuOptions">
				<button className="MenuOptionsButton" onClick={handlerUstawieniaFTP}>
					Ustawienia FTP
				</button>
				<button className="MenuOptionsButton" onClick={logout}>
					LogOut
				</button>
				<button className="MenuOptionsDiv">
					<label htmlFor="scroll" className="MenuOptionsLabel">
						Pasek scroll widoczny
					</label>
					<input type="checkbox" name="scroll" id="scroll" checked={checkBox} className="MenuOptionsCheckbox" onChange={checkBoxChange}></input>
				</button>
			</div>
			{ustawieniaFTP && <OptionsFTP setUstawieniaFTP={setUstawieniaFTP} setBars={props.setBars} setShowMenuOptions={props.setShowMenuOptions} />}
		</>
	);
};
